import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { LoaderComponent } from './core/components/loader/loader.component';
import { ToasterComponent } from './core/components/toaster/toaster.component';
import { CommunicationService } from './shared/services/communication.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, ToasterComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  readonly #communicationService = inject(CommunicationService);
  isAppReady = computed(() => this.#communicationService.isAppReady());
  title = 'dw-bi-ui';

  constructor() {
    (window as any).versionDate = environment.versionDate;
  }
}
